import { render, staticRenderFns } from "./FilterPanel.vue?vue&type=template&id=895d724e&"
import script from "./FilterPanel.vue?vue&type=script&lang=js&"
export * from "./FilterPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports